import { render, staticRenderFns } from "./AccessoriesManagement.vue?vue&type=template&id=29efafd4&"
import script from "./AccessoriesManagement.vue?vue&type=script&lang=js&"
export * from "./AccessoriesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports